var PIXI = require('pixi.js');


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap_preview.js